import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import CssBaseline from '@material-ui/core/CssBaseline'
import Button from '@material-ui/core/Button'
import { withRouter } from 'react-router-dom'
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton
} from 'react-share'
import FacebookIcon from '@material-ui/icons/Facebook'
import TwitterIcon from '@material-ui/icons/Twitter'
import WhatsAppIcon from '@material-ui/icons/WhatsApp'
import HomeIcon from '@material-ui/icons/Home'
import MenuIcon from '@material-ui/icons/Menu'
import IconButton from '@material-ui/core/IconButton'
import Drawer from '@material-ui/core/Drawer'
import CloseIcon from '@material-ui/icons/Close'
import PropTypes from 'prop-types'
import Footer from './Footer'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexGrow: 1
  },
  appBar: {
    flexGrow: 1,
    background: '#047f80',
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  appBarShift: {
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  drawer: {
    flexShrink: 0,
    whiteSpace: 'nowrap'
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar
  },
  content: {
    flexGrow: 1
  },
  rootToolbar: {
    justifyContent: 'space-between'
  },
  button: {
    marginRight: 10,
    fontWeight: 600,
    fontSize: 15
  },
  title: {
    fontSize: 15,
    fontWeight: 600,
    textTransform: 'uppercase',
    cursor: 'pointer'
  },
  img: {
    width: 200
  },
  menuSmall: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    '& a': {
      display: 'block'
    }
  },
  close: {
    position: 'absolute',
    top: 10,
    right: 10
  },
  menu: {
    [theme.breakpoints.down('xs')]: {
      display: 'none'
    }
  }
}))

const MenuList = ({ redirectPage }) => {
  const classes = useStyles()

  return (
    <>
      <Button color="inherit" className={classes.button} href="./">
        <HomeIcon />
      </Button>
      <Button
        color="inherit"
        className={classes.button}
        onClick={() => redirectPage('/resurreccion-bofedales-necesita-lima')}
      >
        Informe I
      </Button>
      <Button
        color="inherit"
        className={classes.button}
        onClick={() => redirectPage('/como-cuida-cusco-agua')}
      >
        Informe II
      </Button>
      <Button
        color="inherit"
        className={classes.button}
        onClick={() => redirectPage('/fuentes-agua-ciudades-sur-peligro')}
      >
        Informe III
      </Button>
    </>
  )
}

Layout.propTypes = {
  redirectPage: PropTypes.func
}

function Layout({ children, history }) {
  const classes = useStyles()
  const url = history.location.pathname
  const [open, setOpen] = useState(false)
  const redirectPage = page => {
    history.push(page)
  }
  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar classes={{ root: classes.rootToolbar }}>
          <IconButton
            edge="start"
            className={classes.menuButton}
            color="inherit"
            aria-label="menu"
            onClick={() => setOpen(prev => !prev)}
          >
            <MenuIcon />
          </IconButton>
          <div className={classes.menu}>
            <MenuList redirectPage={redirectPage} />
          </div>
          <div
            style={{
              display: 'flex',
              minWidth: 100,
              justifyContent: 'space-around'
            }}
          >
            <FacebookShareButton url={process.env.REACT_APP_URL + url}>
              <FacebookIcon />
            </FacebookShareButton>
            <TwitterShareButton url={process.env.REACT_APP_URL + url}>
              <TwitterIcon />
            </TwitterShareButton>
            <WhatsappShareButton url={process.env.REACT_APP_URL + url}>
              <WhatsAppIcon />
            </WhatsappShareButton>
          </div>
        </Toolbar>
      </AppBar>
      <main className={classes.content}>
        <div className={classes.toolbar} />
        <div>{children}</div>
        <Footer />
      </main>
      <Drawer
        open={open}
        onClose={() => setOpen(false)}
        classes={{ paper: classes.menuSmall }}
      >
        <div className={classes.close}>
          <CloseIcon onClick={() => setOpen(false)} />
        </div>
        <MenuList redirectPage={redirectPage} />
      </Drawer>
    </div>
  )
}

Layout.propTypes = {
  children: PropTypes.node,
  history: PropTypes.shape({
    push: PropTypes.func,
    location: PropTypes.object
  })
}

export default withRouter(Layout)
